<div class="wccard" style="border-radius: 6px; overflow: hidden;">
  <div class="sim-modal-header">
    <div class="d-flex">
      <!-- content header -->
      <div class="d-flex flex-column" style="width: 40%;">
        <p *ngIf="!isCalledFromJD && (similarObject?.data?.fullname != null || similarObject?.data?.fullname != undefined)"
          class="mb-1">
          Based on
          <span class="font-weight-600">{{similarObject.data.fullname | titlecase}}'s</span>
          Profile
        </p>
        <p *ngIf="isCalledFromJD" class="mb-1">
          Based on
          <span class="font-weight-600 mr-1">Job Description</span>
          <!-- <span class="text-webbtree-green"> <i class="fa-regular fa-paperclip mr-1 text-webbtree-green"></i> <span>Filename</span></span> -->

        </p>
            <p *ngIf="isCalledFromNLSearch && nlSearchQuery" class="mb-1">
          <span class="font-weight-600 mr-1 line-clamp" matTooltip="{{nlSearchQuery}}"  [matTooltipClass]="{ 'big-tooltip text-black': true }" matTooltipPosition="above">"{{truncateText(nlSearchQuery) | titlecase}}"</span>
          <span> </span>

        </p>
        <p class="f-12 mb-0">You can modify your search based on filters below</p>
        <!-- <p><span class="font-weight-600 mr-3">Note:</span>Fields marked with "<i class="fa-thumbtack fas text-webbtree-green pointer"></i>" are prioritized in the search</p> -->
      </div>
      <!-- modal cta's -->
      <div class="d-flex ms-auto flex-column justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <span *ngIf="!recCandLoader" class="text-right">
              <span class="font-weight-500 f-18">{{recCandCount | indianNumberFormat}}</span> Candidates Found
            </span>
            <span *ngIf="recCandLoader" class="spinner-border text-webbtree-green mb-3">
              <span class="sr-only">Loading...</span>
            </span>
          </div>
            <!-- <div class="missing-field-msg mr-4" *ngIf="getMissedMandatoryFiels()?.length > 0">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>Missing required fields: {{getMissedMandatoryFiels().join(', ')}}</span>
          </div> -->
          <div class="ml-3">
            <button data-testid="auto-app-similar-candidate-filter-button-1" class="btn-trms-white mr-2" (click)="redirectToListing('close')">Cancel</button>

            <button data-testid="auto-app-similar-candidate-filter-button-2" class="btn-trms-small"
              (click)="!(showJobtitleInput || showSkillInput || showLocationInput || showCompanyIndustryInput || showCompanyNameInput || showCompanySizeInput      || showDegreeInput || showDegreeInput || showFieldOfStudyInput || showSchoolInput) && redirectToListing()"
              [ngClass]="{ 'disable-click': showJobtitleInput || showSkillInput || showLocationInput || showCompanyIndustryInput || showCompanyNameInput || showCompanySizeInput || showDegreeInput || showFieldOfStudyInput || showSchoolInput || !validStateForRedirection }">Submit</button>
          </div>
        </div>
        <p *ngIf="!recCandCount && !recCandLoader" class="f-12 ml-2">Not enough results found. Try adjusting the
          filters.
        </p>

      </div>
    </div>
  </div>
  <div class="wccard advsearchbox" style="height: 435px; overflow-y: scroll;">
    <div class="row mx-0">
      <div class="col">
        <p class="font-weight-600 f-12 mt-3 mb-0">Required for this search <span class="font-weight-normal f-12"
            style="font-style: italic;">Limits results to exact matches</span></p>
      </div>
    </div>
    <div class="d-flex">

      <!-- left col -->
      <div class="left-col">
        <!-- jobtitle -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column fields-header">
            <span class="font-weight-600 mr-2 mb-1">Job Title <span class="text-danger">*</span></span>
            <span *ngIf="!isCalledFromJD" class="f-12 text-9696">Examine prevalent job titles from past and present</span>
            <span *ngIf="isCalledFromJD" class="f-12 text-9696">Explore the most frequent job titles across both past and
              present in your talent pool</span>
          </div>

          <div class="mx-4 my-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-1" class="sim-form-control no-shadow inputheight ml-0 w-100" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'jobTitle')"
                  (keyup.enter)="addToSelectedList($event,'jobTitle', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'jobTitle')" placeholder="Add a new Job Title"
                  [matAutocomplete]="jobtitle_auto" [formControl]="jobTitleInput" (blur)="removeTypeahead('jobtitle')" />
                <div *ngIf="showJobtitleInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #jobtitle_auto="matAutocomplete"
                  (optionSelected)="addToSelectedList($event, 'jobTitle')">
                  <mat-option *ngFor="let jt of jobTitleTypeAheads" [value]="{ key: jt.value, doc_count: jt.doc_count }"
                    [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                    matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{jt.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mb-2 mt-4': jobTitleExtendedChipList.length}">
              <app-extended-chiplist [chips]="jobTitleExtendedChipList"
                (change)="setUpdatedChips($event, 'jobTitle')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showJobtitleMandatoryErrorMessage">Maximum one Job Title can be marked as
              mandatory</p>
            <p class="f-12 text-danger font-weight-500 mb-0 mt-2" *ngIf="showJobTitleError">Job title selection is
              mandatory
            </p>
            <!-- ai suggestion -->
            <div style="overflow: hidden;">
              <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
                *ngIf="showOpenAITitleSuggestions && !isOpenAITitleLoading">
                <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                  <i class="fa fa-stars"></i>
                  AI Search Suggestions
                </span>
                <i class="fal fa-info-circle ml-1 pointer"
                  matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
              </div>
              <div *ngIf="isOpenAITitleLoading" class="shimmer-loader ml-1"
                style="height: 23px; width: 300px; border-radius: 10px;"></div>
              <openai-suggested-titles [onlyExisiting]="true" showOnly="titles" [showIcons]="false" [showCount]="false"
                (change)="setTitleSuggestions($event)" (loading)="openaiTitleLoading($event)" [query]="openAIJobTitles"
                [updateChips]="updatedAiTitleChips" [selectedTitles]="selectedTitles" [exclude]="openAIExcludeJobTitles"
                [continent]="[showregion]" [jobtitleAndSkillAIData]="jobtitleAndSkillAIData"></openai-suggested-titles>
            </div>
          </div>
        </div>
        <!-- location -->
        <div class="d-flex fields-box flex-column mb-4">
          <div class="d-flex flex-row fields-header justify-content-between">
            <span class="d-flex flex-column justify-content-center">
              <span class="font-weight-600 mr-2 mb-1">Location
               <!-- <i class="fa-regular fa-circle-info f-12" *ngIf="defaultContinent && locationExtendedChipList?.length == 0" [ngbTooltip]="tooltipTemplate" container="body"></i> -->
             </span>
             <!-- <ng-template #tooltipTemplate>
               Showing results for <b>{{ defaultContinent | titlecase }}</b>, add locations to search globally.
             </ng-template> -->
              <span *ngIf="!isCalledFromJD && locationExtendedChipList?.length > 0" class="text-9696 f-12" >Identify key locations in your search parameters</span>
              <span *ngIf="isCalledFromJD && locationExtendedChipList?.length > 0" class="text-9696 f-12"  >Discover the prime locations within your search
                pool</span>
                  <span  class="text-9696 f-12"  *ngIf="defaultContinent && locationExtendedChipList?.length == 0">Defaults to <b>{{defaultContinent | titlecase}}</b>. Add locations for global search.</span>
            </span>
            <!-- *ngIf="isCalledFromJD" -->
            <!-- <span class="dropdown ats-dropBtn pb-4 d-flex justify-content-center flex-column">
                      <button data-testid="auto-app-similar-candidate-filter-button-3" class="text-webbtree-green" type="button" id="userDropdownButton"
                          appDropdownToggle aria-haspopup="true" aria-expanded="false">
                          <div class="d-flex text-truncate d-flex align-items-center">
                              <i class="fas fa-earth mr-1"></i>
                              <span class="text-capitalize mr-1 text-truncate">{{
                                  !showregion ? 'Select continent' :
                                  showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa':
                                  showregion == 'north america' ? 'North America':
                                  showregion == 'oceania' ? 'Oceania':
                                  showregion == 'south america' ? 'South America': 'Europe'
                              }}
                              </span>
                              <i class="fas fa-chevron-down f-12"></i>
                          </div>
                      </button>
                      <app-continent-selector
                          [parentRegion]="showregion"
                          class="dropdown-menu"
                          style="margin-left: 120px !important; margin-top: 10px!important; position: absolute !important;"
                          aria-labelledby="userDropdownButton"
                      ></app-continent-selector>
                  </span> -->
          </div>

          <div class="m-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-1">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-2" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'location')"
                  (keyup.enter)="addToSelectedList($event, 'location', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'location')" placeholder="Add a new Location"
                  [matAutocomplete]="location_auto" [formControl]="locationInput" (blur)="removeTypeahead('location')" />
                <div *ngIf="showLocationInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #location_auto="matAutocomplete"
                  (optionSelected)="addToSelectedList($event, 'location')">
                  <mat-option *ngFor="let lt of locationTypeAheads"
                    [value]="{ key: lt.value, doc_count: lt.doc_count, continent: lt.location_continent }"
                    [matTooltip]="getTooltipText(lt)" [matTooltipClass]="{ 'eu-tooltip text-black': true }"
                    matTooltipPosition="above" [disabled]="isLocationDisabled(lt)">
                    <span class="">
                      <span class="text-truncate align-items-center">{{lt.value | titlecase}} <span
                          class="float-right text-right ml-auto f-12 mt-2 text-9696">{{lt?.location_type}}</span></span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mt-4': locationExtendedChipList.length}">
              <app-extended-chiplist [chips]="locationExtendedChipList"
                (change)="setUpdatedChips($event, 'location')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <div class="mt-1">
              <p class="f-12 text-danger font-weight-500 mb-0 mt-2" *ngIf="showLocationMandatoryErrorMessage">Maximum one
                Location can be marked as mandatory</p>
              <!-- <p class="f-12 text-danger font-weight-500 mb-0 mt-2" *ngIf="showLocationError">Location selection is
                mandatory</p> -->
            </div>
          </div>
        </div>


      </div>
      <!-- right col -->
      <div class="right-col">
        <!-- skills -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column fields-header justify-content-center pl-4">
            <span class="f-12 font-weight-600 mb-1">Skills</span>
            <span *ngIf="!isCalledFromJD" class="f-12 text-9696">Discover the diverse skills within your search
              findings</span>
            <span *ngIf="isCalledFromJD" class="f-12 text-9696">Discover the diverse skills within your search
              findings</span>
          </div>

          <div class="m-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-3" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'skill')"
                  (keyup.enter)="addToSelectedList($event, 'skill', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'skill')" placeholder="Add a new Skill"
                  [matAutocomplete]="skill_auto" [formControl]="skillInput" (blur)="removeTypeahead('skills')" />
                <div *ngIf="showSkillInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #skill_auto="matAutocomplete" (optionSelected)="addToSelectedList($event, 'skill')">
                  <mat-option *ngFor="let s of skillTypeAheads" [value]="{ key: s.value, doc_count: s.doc_count }"
                    [matTooltip]="s.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                    matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{s.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mt-4 mb-2': skillExtendedChipList.length}">
              <app-extended-chiplist [chips]="skillExtendedChipList"
                (change)="setUpdatedChips($event, 'skill')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showSkillMandatoryErrorMessage">Maximum five skills can be marked as
              mandatory</p>
            <!-- ai suggestion -->
            <div style="overflow: hidden;" [ngClass]="showOpenAISkillsSuggestions && !isOpenAISkillsLoading ? 'mt-4' :''">
              <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
                *ngIf="showOpenAISkillsSuggestions && !isOpenAISkillsLoading">
                <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                  <i class="fa fa-stars"></i>
                  AI Search Suggestions
                </span>
                <i class="fal fa-info-circle ml-1 pointer"
                  matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                  [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
              </div>
              <div *ngIf="isOpenAISkillsLoading" class="shimmer-loader ml-1"
                style="height: 23px; width: 300px; border-radius: 10px;"></div>
              <div class="overflow-hidden">
                <openai-suggested-titles [onlyExisiting]="true" showOnly="skills" [showIcons]="false" [showCount]="false"
                  (change)="setSkillsSuggestions($event)" (loading)="openaiSkillsLoading($event)" [query]="openAISkills"
                  [updateChips]="updatedAiSkillChips" [selectedTitles]="selectedSkills" [exclude]="openAIExcludeSkills"
                  [continent]="[showregion]" [jobtitleAndSkillAIData]="jobtitleAndSkillAIData"></openai-suggested-titles>
              </div>
            </div>
          </div>
        </div>

        <!-- Years of Experience -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column justify-content-center fields-header pl-4">
            <span class="font-weight-600 mr-2 mb-1">Years of Experience</span>
            <span class="text-9696 f-12">Add the range for years of experience</span>
          </div>

          <div class="m-3">
            <div class="d-flex align-items-center">
              <label class="f-12 text-black mr-2">From</label>
              <input data-testid="auto-app-similar-candidate-filter-input-4" class="sim-form-control no-shadow inputheight mb-2 mr-2" style="width: 20%;" type="number" min="0"
                [formControl]="currentyearsofexperienceFrom" placeholder="eg. 1, 2" onwheel="this.blur()"
                (input)="addToSelectedList($event, 'currentfromyearsofexperience')">
              <label class="f-12 text-black mr-2">To</label>
              <input data-testid="auto-app-similar-candidate-filter-input-5" class="sim-form-control no-shadow inputheight mb-2" style="width: 20%;" type="number" min="0"
                [formControl]="currentyearsofexperienceTo" placeholder="eg. 1, 2" onwheel="this.blur()"
                (input)="addToSelectedList($event, 'currenttoyearsofexperience')">
            </div>
            <p style="margin-left: 45px;"
              *ngIf="currentyearsofexperienceFrom.value != null && (currentyearsofexperienceTo.value != null && currentyearsofexperienceTo.value != '') && +currentyearsofexperienceFrom.value >= +currentyearsofexperienceTo.value"
              class="f-12 text-danger mb-0"> Years of experience range is not valid. </p>
            <p style="margin-left: 45px;"
              *ngIf="(+currentyearsofexperienceFrom.value < 0 || +currentyearsofexperienceTo.value < 0)"
              class="f-12 text-danger mb-0"> Enter a valid number in the range</p>
            <p style="margin-left: 45px;"
              *ngIf="!isCalledFromJD && !isCalledFromNLSearch && (currentyearsofexperienceFrom.value == null || currentyearsofexperienceTo.value == null)"
              class="f-12 text-danger mb-0"> Add the range for years of experience. </p>
          </div>


        </div>
          <!-- company industry -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column fields-header">
            <span class="font-weight-600 mr-2 mb-1">Company Industry</span>
            <span *ngIf="isCalledFromJD" class="text-9696 f-12">Explore industries experienced in, both past and
              present</span>
            <span *ngIf="!isCalledFromJD" class="text-9696 f-12">Explore industries experienced in, both past and
              present</span>
          </div>

          <div class="mx-4 my-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-6" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'companyIndustry')"
                  (keyup.enter)="addToSelectedList($event,'companyIndustry', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'companyIndustry')" placeholder="Add a new Industry"
                  [matAutocomplete]="companyIndustry_auto" [formControl]="companyIndustryInput"
                  (blur)="removeTypeahead('companyindustry')" />
                <div *ngIf="showCompanyIndustryInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #companyIndustry_auto="matAutocomplete"
                  (optionSelected)="addToSelectedList($event, 'companyIndustry')">
                  <mat-option *ngFor="let ci of companyIndustryTypeAheads"
                    [value]="{ key: ci.value, doc_count: ci.doc_count }" [matTooltip]="ci.value | titlecase"
                    [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{ci.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mt-4': companyIndustryExtendedChipList.length}">
              <app-extended-chiplist [chips]="companyIndustryExtendedChipList"
                (change)="setUpdatedChips($event, 'companyIndustry')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showCompanyIndustryMandatoryErrorMessage">Maximum one Industry can be
              marked
              as mandatory</p>

          </div>
        </div>


      </div>
    </div>
    <hr class="mb-5">
    <div class="row mx-0">
      <div class="col">
        <p class="font-weight-600 f-12 mt-3 mb-0">Optional preferences <span class="font-weight-normal f-12"
            style="font-style: italic;">Boost relevant profiles without excluding others</span></p>
      </div>
    </div>
    <div class="d-flex">
      <!-- left col -->
      <div class="left-col">
        <!-- company name -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column fields-header">
            <span class="font-weight-600 mr-2 mb-1">Company</span>
            <span *ngIf="isCalledFromJD" class="text-9696 f-12">Explore the companies your talented individuals have
              worked
              with, both in the past and present</span>
            <span *ngIf="!isCalledFromJD" class="text-9696 f-12">Talented individuals worked with diverse companies</span>
          </div>

          <div class="mx-4 my-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-7" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'companyName')"
                  (keyup.enter)="addToSelectedList($event, 'companyName', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'companyName')" placeholder="Add a new Company"
                  [matAutocomplete]="company_auto" [formControl]="companyNameInput"
                  (blur)="removeTypeahead('companyname')" />
                <div *ngIf="showCompanyNameInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #company_auto="matAutocomplete"
                  (optionSelected)="addToSelectedList($event, 'companyName')">
                  <mat-option *ngFor="let comp of companyNameTypeAheads"
                    [value]="{key: comp.key, doc_count: comp.doc_count}" [matTooltip]="comp.key | titlecase"
                    [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="compnaylogoplaceholder mr-2"
                        [ngClass]="{'bg-white': comp?.companylogo , 'bg-color-company': !comp?.companylogo}">
                        <img [src]="comp?.companylogo" *ngIf="comp?.companylogo" class="img-fluid" alt="" />
                        <i class="fas fa-building f-12" *ngIf="!comp?.companylogo"></i>
                      </span>
                      <span class="text-truncate">{{comp.key | titlecase}}</span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mt-4': companyNameExtendedChipList.length}">
              <app-extended-chiplist [chips]="companyNameExtendedChipList"
                (change)="setUpdatedChips($event, 'companyName')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showCompanyNameMandatoryErrorMessage">Maximum one Company can be marked as
              mandatory</p>
          </div>
        </div>
        <!-- company size -->
        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column fields-header">
            <span class="font-weight-600 mr-2 mb-1">Company Size</span>
            <span *ngIf="!isCalledFromJD" class="text-9696 f-12">Explore the size of companies, both past and
              present</span>
            <span *ngIf="isCalledFromJD" class="text-9696 f-12">Explore the size of companies, both past and
              present</span>
          </div>

          <div class="mx-4 my-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative company-size w-100">

                <p-multiSelect [options]="companySizeOption" [(ngModel)]="companySizeInput"
                  (onChange)="addToSelectedList($event, 'companySize', 'submit')" placeholder="Select Company Size"
                  optionLabel="name" [filter]="false" id="p-multiselect">
                  <ng-template let-value pTemplate="selectedItems">
              <!-- <span *ngIf="!value || value.length === 0">
                Select Company Size
              </span> -->
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
                  </ng-template>
                  <ng-template let-cs pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ cs }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>

                <div *ngIf="showJobtitleInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>

              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'px-1 mt-4': companySizeExtendedChipList.length}">
              <app-extended-chiplist [chips]="companySizeExtendedChipList"
                (change)="setUpdatedChips($event, 'companySize')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showCompanySizeMandatoryErrorMessage">Maximum one Company Size can be
              marked
              as mandatory</p>
          </div>
        </div>
      </div>
      <!-- right col -->
      <div class="right-col">

        <!-- Degree -->

        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column justify-content-center fields-header pl-4">
            <span class="font-weight-600 mr-2 mb-1">Degree</span>
            <span *ngIf="isCalledFromJD" class="text-9696 f-12">Degrees achieved by individuals within your talent
              pool</span>
            <span *ngIf="!isCalledFromJD" class="text-9696 f-12">Schools</span>
          </div>

          <div class="m-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-8" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'degree')"
                  (keyup.enter)="addToSelectedList($event, 'degree', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'degree')" placeholder="Add new degree"
                  [matAutocomplete]="degree_auto" [formControl]="degreeInput" (blur)="removeTypeahead('degreeinput')" />
                <div *ngIf="showDegreeInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #degree_auto="matAutocomplete" (optionSelected)="addToSelectedList($event, 'degree')">
                  <mat-option *ngFor="let dt of degreeTypeAheads" [value]="{ key: dt.value, doc_count: dt.doc_count }"
                    [matTooltip]="dt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }"
                    matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{dt.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'mb-3 px-1 mt-4': degreeExtendedChipList.length}">
              <app-extended-chiplist [chips]="degreeExtendedChipList"
                (change)="setUpdatedChips($event, 'degree')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showDegreeMandatoryErrorMessage">Maximum {{maxDegreeMandatoryFieldCount}}
              schools can be marked as mandatory</p>
          </div>
        </div>

        <!-- Field of study -->

        <div class="d-flex flex-column fields-box mb-4">
          <div class="d-flex flex-column justify-content-center fields-header pl-4">
            <span class="font-weight-600 mr-2 mb-1"> Field of study</span>
            <span *ngIf="isCalledFromJD" class="text-9696 f-12">Discover the most popular field of study in your search
              results</span>
            <span *ngIf="!isCalledFromJD" class="text-9696 f-12">Field of study</span>
          </div>

          <div class="m-4">
            <!-- input box -->
            <div class="d-flex align-items-center mb-2">
              <div class="position-relative w-100">
                <input data-testid="auto-app-similar-candidate-filter-input-9" class="sim-form-control no-shadow w-100 inputheight ml-0" #trigger="matAutocompleteTrigger"
                  (click)="typeAheadSearch($event, 'fieldOfStudy')"
                  (keyup.enter)="addToSelectedList($event, 'fieldOfStudy', 'enter');$event.target.blur();trigger.closePanel()"
                  (keyup)="onTypeAheadSearch($event, 'fieldOfStudy')" placeholder="Add new field of study"
                  [matAutocomplete]="fieldOfStudy" [formControl]="fieldOfStudyInput"
                  (blur)="removeTypeahead('fieldofstudy')" />
                <div *ngIf="showFieldOfStudyInputLoader" class="spinner-border position-absolute text-black"
                  style="top: 10px; right: 7px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <mat-autocomplete #fieldOfStudy="matAutocomplete"
                  (optionSelected)="addToSelectedList($event, 'fieldOfStudy')">
                  <mat-option *ngFor="let ft of fieldOfStudyTypeAheads"
                    [value]="{ key: ft.value, doc_count: ft.doc_count }" [matTooltip]="ft.value | titlecase"
                    [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                    <span class="d-flex align-items-center">
                      <span class="text-truncate">{{ft.value | titlecase}} </span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- chiplist -->
            <div [ngClass]="{'mb-3 px-1 mt-4': fieldOfStudyExtendedChipList.length}">
              <app-extended-chiplist [chips]="fieldOfStudyExtendedChipList"
                (change)="setUpdatedChips($event, 'fieldOfStudy')"></app-extended-chiplist>
            </div>
            <!-- error message -->
            <p class="f-12 text-danger" *ngIf="showFieldOfStudyMandatoryErrorMessage">Maximum
              {{maxFieldOfStudyMandatoryFieldCount}} schools can be marked as mandatory</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
